module.exports = require("@swa-ui/core/src/Rating/Rating.module.scss");